import { useEffect, useMemo, useState } from "react"
import { ApproachResult, useListApproach } from "interface/author/approach"

type useApproachProps = {
	searchId: number | undefined
	authorId: number | undefined
}
export const useApproach = ({
	searchId,
	authorId
}: useApproachProps) => {
	const [editApproach, setEditApproach] = useState<{ action: 'create' | 'edit', data: ApproachResult | null } | null>(null)
	const [approachList, setApproachList] = useState<ApproachResult[]>([])
	const approachListState = useListApproach(searchId, authorId)

	useEffect(
		() => {
			if (approachListState.loading) return
			const approachList = approachListState.data?.list
				.filter(approach => {
					if (approach.confidenceScore !== null && approach.confidenceScore <= 1) return false
					if (approach.title === '推定不能' || approach.title === '提案不能') return false
					return true
				}) ?? []
			setApproachList(approachList)
		},
		[approachListState]
	)
	return useMemo(() => ({
		searchId,
		authorId,
		loading: approachListState.loading,
		error: approachListState.error,
		editApproach, setEditApproach,
		approachList, setApproachList
	}), [
		searchId,
		authorId,
		editApproach, setEditApproach,
		approachList, setApproachList,
		approachListState
	])
}
